import { type Components } from '@mui/material/styles';

import { muiButton } from './muiButton';
import { muiCheckbox } from './muiCheckbox';
import { muiCssBaseline } from './muiCssBaseline';
import { muiFilledInput } from './muiFilledInput';
import { muiLink } from './muiLink';
import { muiPaper } from './muiPaper';
import { muiRadio } from './muiRadio';
import { muiSelect } from './muiSelect';
import { muiStepIcon } from './muiStepIcon';
import { muiStepper } from './muiStepper';
import { muiTableCell } from './muiTableCell';
import { muiTooltip } from './muiTooltip';

const overrides = {
  MuiButton: muiButton,
  MuiCheckbox: muiCheckbox,
  MuiCssBaseline: muiCssBaseline,
  MuiFilledInput: muiFilledInput,
  MuiLink: muiLink,
  MuiPaper: muiPaper,
  MuiRadio: muiRadio,
  MuiSelect: muiSelect,
  MuiStepper: muiStepper,
  MuiTableCell: muiTableCell,
  MuiStepIcon: muiStepIcon,
  MuiTooltip: muiTooltip,
} as Components;

export default overrides;
